import React from "react";

const YoungEarnersUnder = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled gap-3 d-flex flex-column">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  1. Rewards for customers under 18
                </h5>
                <ul className="info_description text-dark opacity-50">
                  <li>
                    TopCoin UK is open to customers of all ages. We believe in
                    rewarding loyalty for everyone, including younger customers.
                  </li>
                  <li>
                    However, when it comes to withdrawing any cash-equivalent
                    rewards, TopCoin UK follows a clear and responsible policy.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">2. Participation</h5>
                <p className="info_description text-dark opacity-50 fw-bold mb-0">
                  Customers under the age of 18 may:
                </p>
                <ul className="info_description text-dark opacity-50">
                  <li>Collect TopCoin rewards</li>
                  <li>Unlock loyalty milestones</li>
                  <li>Participate in the TopCoin UK loyalty programme</li>
                </ul>
                <p className="info_description text-dark opacity-50 fw-bold mb-0">
                  Registration for users under 18 requires parent or guardian
                  consent.
                </p>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  3. Receiving Reward Payments
                </h5>
                <p className="info_description text-dark opacity-50 fw-bold mb-0">
                  When a customer under 18 becomes eligible to withdraw a reward
                  from an unlocked wallet, they have two options.
                </p>
                <p>
                  <p className="info_description mt-2 text-dark opacity-50 fw-bold mb-0">
                    Option A — Payment to Their Own Bank Account
                  </p>
                  <p className="info_description  text-dark opacity-50">
                    If the customer has a valid UK youth bank account in their
                    own name, TopCoin UK may transfer the eligible reward to
                    that account.
                  </p>
                  <ul className="info_description my-3 text-dark opacity-50">
                    <li>
                      {" "}
                      The customer or their parent/guardian must ensure the bank
                      details provided are correct.{" "}
                    </li>
                    <li>
                      {" "}
                      Youth bank accounts may have their own limits or
                      conditions set by the bank.
                    </li>
                  </ul>
                  <p className="info_description text-dark opacity-50 fw-bold mb-0">
                    Option B — Payment to Parent or Guardian
                  </p>
                  <p className="info_description text-dark opacity-50">
                    If the customer does not have their own bank account,
                    rewards may be transferred to the parent or guardian’s
                    nominated UK bank account.
                  </p>
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  4. Consent & Verification
                </h5>
                <p className="info_description  text-dark opacity-50">
                  For reward payments to customers under 18:
                </p>
                <ul className="info_description text-dark opacity-50">
                  <li>Parental or guardian consent is required.</li>
                  <li>
                    Proof of identity may be required for both the customer and
                    the parent/guardian before processing a withdrawal.
                  </li>
                </ul>
                <p className="info_description  text-dark opacity-50 my-2">
                  This helps ensure responsible participation and proper
                  safeguarding.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  {" "}
                  5. Platform Responsibility{" "}
                </h5>
                <p className="info_description  text-dark opacity-50">
                  TopCoin UK operates as a loyalty and promotional rewards
                  platform.
                </p>
                <ul className="info_description text-dark opacity-50">
                  <li>
                    The platform records loyalty rewards earned through
                    participation with participating retailers.
                  </li>
                  <li>
                    TopCoin UK is not a bank, investment platform, savings
                    product, or gambling service.
                  </li>
                  <li>
                    Rewards do not earn interest and are not treated as
                    financial deposits.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  6. Cashing Rewards for Individuals Under 18
                </h5>
                <p className="info_description  text-dark opacity-50">
                  Customers under 18 may collect TopCoin, unlock milestones, and
                  participate in the loyalty programme.
                </p>
                <p className="info_description  text-dark opacity-50">
                  Where a reward becomes eligible for withdrawal, parental or
                  guardian consent is required before the reward payment is
                  processed.
                </p>

                <a
                  href="../../../parental_consent_form.pdf"
                  download
                  className=" fw-bold text-decoration-underline text-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Download the parental /guardian content form{" "}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YoungEarnersUnder;
